import {
    IonAlert,
    IonContent, IonInput,
    IonPage,
} from '@ionic/react';
import React, {Component} from 'react';

import {Helmet} from 'react-helmet';
import {withRouter} from 'react-router-dom';
import MFooter from "../../components/MFooter";
import Script from "react-load-script";
import "./css/captcha.css"
import cookieUtil from "../../utils/cookieUtil";
import {LoginForPcByPwd} from "./Service";
import {jumpOtherUrl} from "../../utils/common";
import {PlatMd5} from "../../utils/platMd5";
import {getQueryVariable} from "../../utils/commonFunction";

class PhoneLogin extends Component {

    constructor(props) {
        super(props);
        this.state = {
            accounts: '',
            password: null,
            accountsTip: 0,
            passwordTip: 0,
            callBackUrl: '',
            isShowTip: false,
            showTipMsg: null,
            scriptLoaded: false,
            showTipModal: false,
            scene: 'login',
            sessionid: null,
            sig: null,
            token: null
        }
    }

    componentDidMount() {
        const script = document.createElement("script");
        script.src = "//hm.baidu.com/hm.js?64f9bb47cd627a8a4069b1e07b127e1f";
        script.async = true;
        document.body.appendChild(script);
        let callBackUrl = getQueryVariable("callback");
        if (callBackUrl != null) {
            this.setState({callBackUrl})
        }
    }

    handleScriptError = () => {
        this.setShowTipModal('组件加载失败')
    }

    handleScriptLoad = () => {
        this.capthcha();
    }

    capthcha = () => {
        const {scene} = this.state;
        const _that = this;
        // eslint-disable-next-line
        AWSC.use("nc", function (state, module) {
            // 初始化
            window.nc = module.init({
                // 应用类型标识。它和使用场景标识（scene字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的appkey字段值，请务必正确填写。
                appkey: "FFFF00000000016860BF",
                //使用场景标识。它和应用类型标识（appkey字段）一起决定了滑动验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的scene值，请务必正确填写。
                scene: scene,
                // 声明滑动验证需要渲染的目标ID。
                renderTo: "#dom_id",
                //前端滑动验证通过时会触发该回调参数。您可以在该回调参数中将会话ID（sessionId）、签名串（sig）、请求唯一标识（token）字段记录下来，随业务请求一同发送至您的服务端调用验签。
                success: function (data) {
                    _that.setState({
                        sessionid: data.sessionId,
                        sig: data.sig,
                        token: data.token
                    })
                },
                // 滑动验证失败时触发该回调参数。
                fail: function (failCode) {
                    window.console && console.log(failCode);
                    this.setState({
                        errTip: true,
                        showTipMsg: '托动滑块到最右边，显示验证成功后松开鼠标。'
                    })
                },
                // 验证码加载出现异常时触发该回调参数。
                error: function (errorCode) {
                    window.console && console.log(errorCode);
                    this.setState({
                        errTip: true,
                        showTipMsg: '托动滑块到最右边，显示验证成功后松开鼠标。'
                    })
                }
            });
        })
    }

    /**
     * 账号密码登录
     */
    showView = () => {
        const {accounts, password, callBackUrl, scene, sessionid, sig, token,} = this.state;
        if (accounts === "" || accounts === null) {
            this.setState({
                accountsTip: 1,
            })
            return;
        }
        if (password === null || password === "") {
            this.setState({
                passwordTip: 1,
            })
            return;
        }
        if (sessionid == null || sig == null || token == null) {
            this.setState({
                isShowTip: true,
                showTipMsg: '托动滑块到最右边，显示验证成功后松开鼠标。'
            })
            return;
        }

        const urlParms = {
            'userName': accounts,
            'password': PlatMd5.hashStr(password).toUpperCase(),
            'callBackUrl': this.state.callBackUrl,
            'sessionid': sessionid,
            'sig': sig,
            'token': token,
            'scene': scene,
        }

        LoginForPcByPwd(urlParms).then(ret => {
            if (ret.code === '10000') {
                console.log(ret.data);
                //写cookie，跳转页面
                let token = ret.data.accessToken;
                cookieUtil.put("access_token", token);
                cookieUtil.remove("userInfo")
                let url = '';
                if (callBackUrl !== "" && callBackUrl != null) {
                    url = decodeURIComponent(callBackUrl)
                }
                jumpOtherUrl(url);
            } else {
                this.setState({
                    isShowTip: true,
                    showTipMsg: ret.msg
                });
                //window.location.reload();
            }
        }).catch(err => {
            console.log(err);
        });
    }

    closeTipBox = () => {
        this.setState({
            isShowTip: false,
            showTipMsg: null
        })
    }

    render() {
        const {
            accountsTip,
            passwordTip,
        } = this.state;

        return (
            <IonPage>
                <meta name="viewport" content="width=750,target-densitydpi=device-dpi,user-scalable=no"/>
                <meta name="format-detection" content="telephone=no"/>
                <meta name="apple-mobile-web-app-capable" content="yes"/>
                <meta name="apple-mobile-web-app-status-bar-style" content="black"/>
                <IonContent fullscreen>
                    <Helmet placeholder={""}>
                        <link rel="stylesheet" href="//m.91y.com/templets/default/20190813/css/91y_phone.css"
                              type="text/css"/>
                        <link rel="stylesheet"
                              href="//m.91y.com//templets/default/20190813/css/91y_public.css?v=2021012801"
                              type="text/css"/>
                    </Helmet>
                    <div className="p-box">
                        <div className="login-box">
                            <div className="logo"></div>
                            <Script
                                url="https://g.alicdn.com/AWSC/AWSC/awsc.js"
                                onError={this.handleScriptError}
                                onLoad={this.handleScriptLoad}
                            />
                            <div className="content js-I">
                                <ul>
                                    <li>
                                        <IonInput type="text" className="ipt" value={this.state.accounts}
                                                  onIonChange={e => this.setState({accounts: e.detail.value})}
                                                  placeholder="请输入91y账号"/>
                                        <div className={accountsTip > 0 ? "recharge-tip-new" : "dn"}>请输入91y账号</div>
                                    </li>
                                    <li>
                                        <IonInput type="password" className="ipt"
                                                  value={this.state.password}
                                                  onIonChange={e => this.setState({password: e.detail.value})}
                                                  placeholder="请输入密码"/>
                                        <div className={passwordTip > 0 ? "recharge-tip-new" : "dn"}>请输入密码</div>
                                    </li>
                                    <li style={{width: "694px", height: "90px"}}>
                                        <div className="validation">
                                            <div id="dom_id"></div>
                                        </div>
                                    </li>
                                </ul>
                            </div>

                            <a className="login-btn" onClick={() => this.showView()}>登录</a>
                            <a href="/h5register" className="register-btn">立即注册</a>
                        </div>
                        {/*<!------------版权----------------->*/}
                        <MFooter title={""} isJumpLogin={false}/>
                    </div>
                </IonContent>
                <IonAlert
                    isOpen={this.state.isShowTip}
                    onDidDismiss={() => this.closeTipBox()}
                    header="温馨提示"
                    message={this.state.showTipMsg}
                    buttons={['OK']}
                />
            </IonPage>
        );
    }
}

export default withRouter(PhoneLogin);
